"use client";

import { useState } from "react";

export type QA = { q: string; a: string };

export function Faq({ items }: { items: QA[] }) {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <div className="mx-auto max-w-3xl">
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={it.q} className={`mt-2.5 overflow-hidden rounded-[10px] border bg-white transition first:mt-0 ${isOpen ? "border-action/40 shadow-soft" : "border-line"}`}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-extrabold text-ink"
            >
              {it.q}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" className={`shrink-0 text-muted transition-transform ${isOpen ? "rotate-45" : ""}`}>
                <path d="M12 5v14M5 12h14" />
              </svg>
            </button>
            <div className={`grid transition-all duration-200 ${isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
              <div className="overflow-hidden">
                <p className="px-5 pb-5 text-[14px] leading-relaxed text-slate" dangerouslySetInnerHTML={{ __html: it.a }} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
